import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SplashScreenComponent } from './_metronic/partials/layout/splash-screen/splash-screen.component';
import { SplashScreenService } from './_metronic/partials/layout/splash-screen/splash-screen.service';
import { ThemeModeService } from './_metronic/partials/layout/theme-mode-switcher/theme-mode.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, SplashScreenComponent],
})
export class AppComponent implements OnInit {
  private modeService = inject(ThemeModeService);
  private splash = inject(SplashScreenService);

  ngOnInit() {
    this.modeService.init();
    // Hide splash once core services initialized (microtask allows child view init)
    queueMicrotask(() => this.splash.hide());
  }
}
